<main>

  <div class="mx-4 mb-10">
    @if (componentType === UserAdminComponentTypeEnum.PRIVILEGE) {
      <h3 class="text-4xl font-bold mb-2">Moderadores &
      Administradores</h3>
    }
    @if (componentType == UserAdminComponentTypeEnum.ALL) {
      <h3 class="text-4xl font-bold mb-2">Todos Utilizadores</h3>
    }
    @if (componentType == UserAdminComponentTypeEnum.BLOCKED) {
      <h3 class="text-4xl font-bold mb-2">Utilizadores
      bloqueados</h3>
    }

    @if (componentType == UserAdminComponentTypeEnum.PRIVILEGE) {
      <p class="text-sm">
      Faça a gestão de utilizadores que possuem privilégios na plataforma</p>
    }

    @if (componentType == UserAdminComponentTypeEnum.ALL) {
      <p class="text-sm">
      Faça a gestão de todos os utilizadores existentes na plataforma</p>
    }

    @if (componentType == UserAdminComponentTypeEnum.BLOCKED) {
      <p class="text-sm">
      Lista de utilizadores que foram bloqueados na plataforma</p>
    }
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros -->
    <div class="my-5">
      <app-user-filters [componentType]="componentType" (submitFilter)="onFilterSubmit($event)"></app-user-filters>
    </div>

    <!-- filtros -->
    <app-user-table-list [componentType]="componentType" [users]="users"
    [hasData]="users.length > 0"></app-user-table-list>

    <!-- paginação -->
    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
      (pageChangeEvent)="onPageChange($event)"></app-paginator>
    }

  </div>
</main>
